/** Structural palette/class for path-scoped Contentful dark video blocks under rebrand. */
export function getContentfulVideoBlockSurface({
  backgroundColor,
  rebrandBeigeScope,
  isRebrand,
}: {
  backgroundColor: App.ComponentVideoBlock['backgroundColor']
  rebrandBeigeScope: boolean
  isRebrand: boolean
}): {
  paletteType: App.Design.PaletteType
  isPathScopedBeigeDark: boolean
} {
  const isPathScopedBeigeDark = rebrandBeigeScope && backgroundColor === 'dark' && isRebrand

  return {
    isPathScopedBeigeDark,
    paletteType: backgroundColor === 'dark' && !isPathScopedBeigeDark ? 'inverse' : 'default',
  }
}

/**
 * Contentful hero carousels: beige under rebrand (default palette + CSS),
 * full inverse tokens for legacy (no partial CSS remap).
 */
export function getContentfulHeroOfferCarouselPalette(
  isRebrand: boolean,
): App.Design.PaletteType {
  return isRebrand ? 'default' : 'inverse'
}
